import React, { useEffect, useRef, useState } from 'react'
import html2canvas from 'html2canvas'
import styled from 'styled-components'
import DownloadButton from '../components/DownloadButton'
import { MediaQueries as Mq } from '../styles/MediaQueries'
import { useTranslation } from 'react-i18next'

const Container = styled.div`
  position: absolute;
  top: 200px;
  left: -50000px;
  width: 1400px;
  min-height: 650px;
  z-index: 1000;
  padding: 2rem;
`
const TitleForDownload = styled.p`
  font-weight: bold;
  font-size: 1.7rem;
  color: var(--baseBlue);
  margin-bottom: 2rem;
  ${Mq.xs} {
    font-size: 1.4rem;
  }
`
const ImageExport = ({ children, title, dataSource }) => {
  const exportRef = useRef()
  const [download, setDownload] = useState(false)
  const [date, setDate] = useState('')
  const { t } = useTranslation()

  const onDownloadClick = () => {
    setDownload(true)
  }
  useEffect(() => {
    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }
    const date = new Date().toLocaleDateString(undefined, options)
    setDate(date)

    if (download) {
      setTimeout(() => {
        html2canvas(exportRef.current, { scale: 1 }).then((canvas) => {
          const a = document.createElement('a')
          a.href = canvas
            .toDataURL('image/png')
            .replace('image/jpeg', 'image/octet-stream')
          a.download = `${title}.png`
          a.click()
          setDownload(false)
        })
      }, 500)
    }
  }, [download, title])
  return (
    <>
      <DownloadButton onClick={onDownloadClick} />
      <Container ref={exportRef} aria-hidden="true">
        <TitleForDownload>{title}</TitleForDownload>
        {children}
        <p>{t('Immunization Agenda 2030 Scorecard')}</p>
        <p dangerouslySetInnerHTML={{ __html: dataSource }}></p>
        <div>
          {`${date}`} &#169; {`${t('Immunization Agenda 2030')}`}
        </div>
      </Container>
    </>
  )
}

export default ImageExport
